import {useQuery} from "@apollo/client";
import {Link} from "react-router";

import Button from "@/components/button/Button";
import {GQL_SUBSCRIPTION_PACKS, SubscriptionPacksResponse} from "@/lib/queries/billing.ts";
import {BillingPeriod} from "@/lib/types/billing";
import {CallToActionBlock} from "@/pages/billing/subscription-summary/CallToActionBlock.tsx";
import {SubscriptionPackTierWrapped} from "@/pages/billing/v2/subscriptions/Subscriptions.tsx";

export const ChangeToAnnually = () => {
  const {data} = useQuery<SubscriptionPacksResponse>(GQL_SUBSCRIPTION_PACKS, {
    fetchPolicy: "no-cache",
    nextFetchPolicy: "no-cache",
  });

  const forcedPacks: SubscriptionPackTierWrapped[] = (data?.subscriptionPacks?.items || [])
    .filter((p) => p.default_values.is_active)
    .map((p) => {
      const packOption = p.tiers.find((o) => o.tier_id === p.default_values.tier_id);
      return {packTitle: p.title, ...packOption!};
    });
  return (
    <div>
      <h3 className="my-4 fs-5">Change Billing Period</h3>
      <CallToActionBlock text="Switch your billing cycle to Annual, and save 20% on all plans">
        <Button
          as={Link}
          to="/billing/checkout"
          state={{
            bundle: forcedPacks,
            billingPeriod: BillingPeriod.YEAR,
          }}
        >
          Change To Annual
        </Button>
      </CallToActionBlock>
    </div>
  );
};
